export default __webpack_public_path__ + "assets/otf/9456fa40117c9472546b15f9e7e91a19.otf";